export const SMS = {
  nav: "nav-sms-sandbox-test",
  page: "sms-sandbox-test-page",
  title: "sms-sandbox-test-title",
  destination: "sms-sandbox-test-destination",
  message: "sms-sandbox-test-message",
  send: "sms-sandbox-test-send-btn",
  result: "sms-sandbox-test-result",
  messageId: "sms-sandbox-test-message-id",
  configSet: "sms-sandbox-test-config-set",
  origination: "sms-sandbox-test-origination",
};
